import * as React from "react";
import { useNavigate } from "react-router-dom";
import "./style.scss";
const UseOrderBox = (props: Types.Cons.IOrderProps) => {
  // console.log("orderInfo =>", props.orderInfo);
  const { orderInfo } = props;
  let navigate = useNavigate(); // 路由跳转

  const payMoney = (data: any) => {
    console.log("data =>", data);
    return;
    // if (state.account === "") {
    //   popBox("请输入账号");
    //   return;
    // }
    // let params = {
    //   account: state.account,
    //   goods_spec_id: Number(state.goodsSpecID)
    // };
    // console.log("params =>", params);
    // api.pay.payMoney(params).then((resp) => {
    //   if (resp.code === 1) {
    //     (window as any).openWebPage(resp.data.pre_pay_url);
    //   } else {
    //     setIsRc(!isRc);
    //   }
    //   console.log("pay =>", resp);
    // });
  };

  return (
    <div className="order-box">
      <div className="order-head">
        <span className="order-number">订单号: {orderInfo?.order_sn}</span>
        {orderInfo?.status === 2 || orderInfo?.status === 3 ? (
          <span className="order-state">{orderInfo?.status_txt}</span>
        ) : (
          <span className="order-state" style={{ color: "red" }}>
            {orderInfo?.status_txt}
          </span>
        )}
      </div>
      <div className="order-main">
        <img src={orderInfo?.goods_image} alt="" className="goods-img" />
        <div className="order-goods-info">
          <p className="goods-name">{orderInfo?.goods_spec_value}</p>
          <p className="goods-tel">充值账号: {orderInfo?.account}</p>
        </div>
      </div>
      <div className="order-money">
        <span className="money-p">实付款: ¥{orderInfo?.pay_money}</span>
        <div>
          {/* {orderInfo?.status === 1 ? (
            <button
              type="button"
              className="payBtn goPayBtn"
              onClick={() => payMoney(orderInfo)}
            >
              立即支付
            </button>
          ) : null} */}
          <button
            type="button"
            className="payBtn"
            onClick={() =>
              navigate(
                `/?goods_type_id=${orderInfo?.goods_type_id}&goods_id=${orderInfo?.goods_id}&product_id=${orderInfo?.goods_spec_id}`
              )
            }
          >
            再次购买
          </button>
        </div>
      </div>
    </div>
  );
};

export default UseOrderBox;
